import React, { useEffect, useState } from "react";
// import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import "./sumissionguideline.css"; // Ensure the correct path

const SubmissionGuideline = () => {
  // Static content - commented out API calls
  const staticGuideline = `Abstracts should be composed in English and limited to 300 words. Utilize Times New Roman, 12-point font, with 1-inch (2.54 cm) margins and single-spacing. Ensure the title is concise and in Title Case, with all authors' full names and affiliations listed, designating the corresponding author with an asterisk. The abstract must encompass a brief background, objective, methods, results, and conclusion. Submissions are to be made online in .doc, .docx, or .pdf format, with accepted abstracts published in the conference proceedings, provided the authors register and present at the conference. Abstracts are submitted online through the submission system below or via email (icetsd@just.edu.bd).`;

  const staticSubmissionProcess = [
    "Create an author account if you do not have any, otherwise directly login using your author account",
    "Use our submission system, accessible from author dashboard",
    "Provide all the information required including title, abstract, author information, abstract file.",
    "Authors can track their submission in the author account dashboard"
  ];

  const staticResearchAreas = [
    {
      mainDomain: "Biomedical Engineering and Bioscience",
      subDomains: [
        "Advances in medical imaging technology",
        "Biomedical and health informatics",
        "Biomedical signal processing",
        "Biorobotics and biomachines"
      ]
    },
    {
      mainDomain: "Chemical Engineering and Material Science",
      subDomains: [
        "Biomaterials and bio-sensors",
        "Chemical process technology",
        "Chemical safety and management",
        "Emerging technologies in chemical engineering",
        "Nanotechnology and application"
      ]
    },
    {
      mainDomain: "Computational Intelligence and Applications",
      subDomains: [
        "Artificial Intelligence and Machine Learning",
        "Cyber Security",
        "Data Science and Statistics",
        "Green software engineering and sustainable computing",
        "Intelligent computing",
        "Smart Agriculture and IoT"
      ]
    },
    {
      mainDomain: "Electrical, Electronics, and Communication Engineering",
      subDomains: [
        "Application of power electronics",
        "Distributed power generation and Smart power grid",
        "Electronics and communication",
        "Power system planning and optimization",
        "Renewable Energy Application",
        "Sustainable Energy Management",
        "Waste-to-energy"
      ]
    },
    {
      mainDomain: "Environmental Science and Climate Change",
      subDomains: [
        "Air, water, and soil quality",
        "Biodiversity and climate action",
        "Disaster and risk management associated with climate change",
        "Emerging contaminants and remedial techniques",
        "Green technologies for sustainable solutions",
        "Remote sensing and resource monitoring",
        "Sustainable technology for environmental protection"
      ]
    },
    {
      mainDomain: "Mechanical, Industrial and Production Engineering",
      subDomains: [
        "Advanced machinery and automation",
        "Cross cutting issues in industrial development",
        "Innovative manufacturing technologies",
        "Intelligent robotics and control",
        "Product control and management",
        "Smart supply chain management"
      ]
    },
    {
      mainDomain: "Petroleum, Mining, and Ocean Technology",
      subDomains: [
        "Geology, mineralogy, and exploration geochemistry",
        "Marine plastic pollution",
        "Mining engineering and technology development",
        "Ocean technology and blue economy",
        "Petroleum geoscience and technology",
        "Non-renewable energy"
      ]
    },
    {
      mainDomain: "Textile Engineering and Sustainable Technology",
      subDomains: [
        "Composite materials and industrial textiles",
        "Fiber science and technology",
        "Life cycle analysis and sustainability",
        "Modern spinning and weaving technology",
        "Sustainable dyes and chemical management",
        "Textile chemical and manufacturing processes"
      ]
    },
    {
      mainDomain: "Nuclear, Plasma, Radiological Engineering",
      subDomains: [
        "Nuclear fusion, fission",
        "Plasma processing and plasma treatment",
        "Thin Film Deposition",
        "Material Interaction, coating and surface technology"
      ]
    }
  ];

  const [guideline, setGuideline] = useState(staticGuideline);
  const [domains, setDomains] = useState([]);
  const [selectedDomain, setSelectedDomain] = useState([]); // Track multiple selected domains
  const [researchAreas, setResearchAreas] = useState(staticResearchAreas);
  const [submissionProcess, setsubmissionProcess] = useState(staticSubmissionProcess);
  // const [loading, setLoading] = useState(true); // Add loading state
  // const [error, setError] = useState(null); // Add error state

  // Commented out API calls - using static content
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/get-update-submission`
  //       ); // Adjust the URL as needed
  //       if (response.data.length > 0) {
  //         const data = response.data[0]; // Get the first document from the array
  //         setGuideline(data.guideline || "");
  //         setsubmissionProcess(data.submissionProcess || []);
  //       }
  //       setLoading(false); // Set loading to false after data is fetched
  //     } catch (error) {
  //       console.error("Error fetching submission guideline:", error);
  //       setError("Error fetching data"); // Set error message
  //       setLoading(false); // Set loading to false even if there is an error
  //     }
  //   };

  //   fetchData();
  // }, []); // Empty dependency array means this effect runs once on mount

  // // Fetch domains and subdomains
  // useEffect(() => {
  //   const fetchDomainsData = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/get-cutomize-domains`
  //       );
  //       setDomains(response.data || []);
  //     } catch (error) {
  //       console.error("Error fetching domains:", error);
  //       setError("Error fetching domains data");
  //     }
  //   };

  //   fetchDomainsData();
  // }, []); // Empty dependency array means this effect runs once on mount
  const handleDomainClick = (index) => {
    // Calculate which row the clicked card is in (assuming 3 cards per row)
    const cardsPerRow = 3;
    const rowIndex = Math.floor(index / cardsPerRow);
    const startIndex = rowIndex * cardsPerRow;
    const endIndex = Math.min(startIndex + cardsPerRow - 1, researchAreas.length - 1);
    
    // Get all indices in the same row
    const rowIndices = [];
    for (let i = startIndex; i <= endIndex; i++) {
      rowIndices.push(i);
    }
    
    setSelectedDomain(prev => {
      // Check if any card in this row is currently expanded
      const isRowExpanded = rowIndices.some(idx => prev.includes(idx));
      
      if (isRowExpanded) {
        // If row is expanded, collapse all cards in this row
        return prev.filter(id => !rowIndices.includes(id));
      } else {
        // If row is collapsed, expand all cards in this row
        const newSelected = [...prev];
        rowIndices.forEach(idx => {
          if (!newSelected.includes(idx)) {
            newSelected.push(idx);
          }
        });
        return newSelected;
      }
    });
  };

  // Commented out loading and error handling since using static content
  // if (loading) {
  //   return <div>Loading...</div>; // Show loading indicator
  // }

  // if (error) {
  //   return <div>{error}</div>; // Show error message if any
  // }

  function formatGuidelineText(text) {
    const lines = text
      .split("\n")
      .map((line) => line.trim())
      .filter(Boolean);
    const elements = [];
    let currentOl = null;
    let currentUl = null;

    const urlify = (text) =>
      text.replace(
        /(https?:\/\/[^\s]+)/g,
        (url) => `<a href="${url}" target="_blank">${url}</a>`
      );

    lines.forEach((line, index) => {
      if (/^\d+\.\s/.test(line)) {
        // Start of a numbered item
        if (!currentOl) currentOl = [];
        if (currentUl) {
          // Close previous sublist
          currentOl.push(<ul key={`ul-${index}`}>{currentUl}</ul>);
          currentUl = null;
        }
        currentOl.push(
          <li
            key={`ol-li-${index}`}
            dangerouslySetInnerHTML={{
              __html: urlify(line.replace(/^\d+\.\s/, "")),
            }}
          />
        );
      } else if (/^([ivxlc]+)\)\s/i.test(line)) {
        // Sub-item (roman numeral pattern like i), ii), etc.)
        if (!currentUl) currentUl = [];
        currentUl.push(
          <li
            key={`ul-li-${index}`}
            dangerouslySetInnerHTML={{
              __html: urlify(line.replace(/^([ivxlc]+)\)\s/i, "")),
            }}
          />
        );
      } else {
        // Regular paragraph or last line
        if (currentUl && currentOl) {
          currentOl.push(<ul key={`ul-end-${index}`}>{currentUl}</ul>);
          currentUl = null;
        }
        if (currentOl) {
          elements.push(<ol key={`ol-${index}`}>{currentOl}</ol>);
          currentOl = null;
        }
        elements.push(
          <p
            key={`p-${index}`}
            dangerouslySetInnerHTML={{ __html: urlify(line) }}
          />
        );
      }
    });

    // Flush remaining lists
    if (currentUl && currentOl) {
      currentOl.push(<ul key="ul-last">{currentUl}</ul>);
      currentUl = null;
    }
    if (currentOl) {
      elements.push(<ol key="ol-last">{currentOl}</ol>);
    }

    return elements;
  }

  return (
    <div className="submission-guideline-container">
      <div className="guideline-section">
        <div className="heading-container">
          <h4>Submission Guideline</h4>
        </div>
        <div className="guideline-content">
          {formatGuidelineText(guideline)}
        </div>
      </div>
      
      <div className="submission-process-section">
        <div className="heading-container">
          <h4>Submission Process</h4>
        </div>
        <ol>
          {submissionProcess.length > 0 ? (
            submissionProcess.map((step, index) => <li key={index}>{step}</li>)
          ) : (
            <li>No submission process available</li>
          )}
        </ol>
      </div>

      <div className="domain-section">
        <div className="heading-container">
          <h4>Research Areas</h4>
        </div>
        <div className="research-areas-cards">
          {researchAreas.length > 0 ? (
            researchAreas.map((area, index) => (
              <div key={index} className="research-area-card">
                <div 
                  className="research-area-header"
                  onClick={() => handleDomainClick(index)}
                >
                  <h5 className="research-area-title">{area.mainDomain}</h5>
                  <FontAwesomeIcon
                    icon={selectedDomain.includes(index) ? faChevronDown : faChevronRight}
                    className="chevron-icon"
                  />
                </div>
                {selectedDomain.includes(index) && (
                  <div className="research-area-subdomains">
                    <ul>
                      {area.subDomains.map((subdomain, subIndex) => (
                        <li key={subIndex} className="subdomain-item">
                          {subdomain}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            ))
          ) : (
            <p>No research areas available</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubmissionGuideline;
